export const VISIBLE_TO = 'visibleTo';
export const CUSTOMIZABLE_COLUMNS = ['bounce', 'bouncerate', 'hardbounced', 'hardbouncerate', 'softbounced', 'softbouncerate', 'click', 'clickrate', 'clickthroughrate', 'created', 'delivered', 'deliveredrate', 'open', 'openrate', 'publishDate', 'reply', 'replyrate', 'sent', 'spamreport', 'spamreportrate', 'unsubscribed', 'unsubscribedrate', 'updated', 'subjectline', VISIBLE_TO];
export const COLUMN_COUNTER_KEYS = ['bounce', 'hardbounced', 'softbounced', 'click', 'open', 'sent', 'reply', 'spamreport', 'unsubscribed', 'delivered'];
export const DATE_COLUMN_KEYS = ['created', 'updated', 'publishDate'];
export const COLUMN_TO_RATIO_KEY = {
  bouncerate: 'bounceratio',
  hardbouncerate: 'hardbounceratio',
  softbouncerate: 'softbounceratio',
  clickrate: 'clickratio',
  clickthroughrate: 'clickthroughratio',
  deliveredrate: 'deliveredratio',
  openrate: 'openratio',
  replyrate: 'replyratio',
  spamreportrate: 'spamreportratio',
  unsubscribedrate: 'unsubscribedratio'
};
export const FOLDER_CREATE_ERRORS = {
  FOLDER_CATEGORY_LIMIT: 'FOLDER_CATEGORY_LIMIT'
};
export const FILTER = 'filter';
export const SEARCH = 'search';

// old empty state conditions
export const CREATE_AN_EMAIL_STATE = 'createAnEmail';
export const NO_MATCH_SEARCH = 'noMatchSearch';
export const NO_MATCH_FILTER = 'noMatchFilter';
export const NO_DRAFT_EMAIL = 'noDraftEmails';
export const NO_SCHEDULED_EMAIL = 'noScheduledEmails';
export const NO_SENT_EMAIL = 'noSentEmails';
export const NO_ARCHIVED_EMAIL = 'noArchivedEmails';
export const UNARCHIVED = 'unarchived';
export const APPROVALS = 'approvals';
export const FOLDER = 'folder';
export const LIST = 'list';
export const ALL_USERS = 'ALL_USERS';
export const ALL_TEAMS = 'ALL_TEAMS';

// Custom views are number based, hence the need for `\\d+`
export const MANAGE_URL_REG = new RegExp('^/email/[0-9]+/manage/state/(all|draft|scheduled|sent|archived|ai|issues|deleted|\\d+)?$');
export const FOLDER_URL_REG = new RegExp('^/email/\\d+/manage/folder(?:/\\d+)?');
export const AFFECTED_EMAILS_URL_REG = new RegExp('^/email/[0-9]+/manage/affected-emails$');